export const availability = 'AVAILABILITY';

export const trendViewBy = {
  day: {
    label: 'Day',
    view: 'Daily',
    plural: 'Days',
    divider: 1,
    default: 89,
  },
  week: {
    label: 'Week',
    view: 'Weekly',
    plural: 'Weeks',
    divider: 7,
    default: 364,
    weekRange: 6,
  },
  month: {
    label: 'Month',
    view: 'Monthly',
    plural: 'Months',
    divider: 30,
    default: 729,
  },
};
export const defaultTrendViewBy = 'week';
export const monthTrend = 'month';

export const trendsSplitter = '_#~';
export const trendsFavSplitter = '$$';
export const objectivesSplitter = '~!';

export const trendsUrgencyObj = { PLAN: 'PLAN', URGENT: 'URGENT' };

export const TEMP_CONSUMP_KEY = 'tempConsump';

export const ASSET_SUM_ONB_ID = 'ONB';

export const SORT_OPTION = {
  ALPHABETICAL: 'alphabetical',
  HIGH_TO_LOW: 'highToLow',
  LOW_TO_HIGH: 'lowToHigh',
};

export const activityLabelMap = {
  none: 'None_of_the_units_have_activities',
  some_without_activities: 'Some_units_without_activities',
};
